/* APO replaces amount contents. Preserve accessible labels without changing money. */
(() => {
  const source = document.currentScript;
  const productId = source?.dataset.productId;
  if (!productId || !/^\d+$/.test(productId)) return;
  const labels = source.dataset;
  const observers = new Map();
  let scheduled = false;

  function locallyVisible(node, container) {
    if (!node) return false;
    for (let current = node; current && current !== container; current = current.parentElement) {
      const style = getComputedStyle(current);
      if (current.hidden || current.getAttribute('aria-hidden') === 'true' ||
          style.display === 'none' || style.visibility === 'hidden') return false;
    }
    return true;
  }

  function preserveLabel(amount, text, visible) {
    if (!amount) return;
    const nativeLabel = amount.querySelector('.visually-hidden');
    let sibling = amount.previousElementSibling;
    if (nativeLabel) {
      if (sibling?.hasAttribute('data-italflex-apo-price-label')) sibling.remove();
      return;
    }
    if (!sibling?.classList.contains('visually-hidden')) {
      sibling = document.createElement('span');
      sibling.className = 'visually-hidden';
      sibling.setAttribute('data-italflex-apo-price-label', '');
      amount.before(sibling);
    }
    const value = `${text} `;
    if (sibling.textContent !== value) sibling.textContent = value;
    if (sibling.hidden === visible) sibling.hidden = !visible;
  }

  function refresh(container) {
    const price = container.querySelector('.price');
    const compare = container.querySelector('.compare-at-price');
    const showCompare = locallyVisible(compare, container);
    preserveLabel(price, showCompare ? labels.saleLabel : labels.priceLabel, true);
    preserveLabel(compare, labels.regularLabel, showCompare);
  }

  function update() {
    scheduled = false;
    for (const [container, observer] of observers) {
      if (!container.isConnected) {
        observer.disconnect();
        observers.delete(container);
      }
    }
    const selector = `product-price[data-product-id="${productId}"] [ref="priceContainer"], sticky-add-to-cart [ref="priceContainer"]`;
    document.querySelectorAll(selector).forEach(container => {
      if (!observers.has(container)) {
        const observer = new MutationObserver(schedule);
        observer.observe(container, {
          childList: true,
          characterData: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['hidden', 'style', 'aria-hidden']
        });
        observers.set(container, observer);
      }
      refresh(container);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    queueMicrotask(update);
  }

  document.addEventListener('mwApo::ready', schedule);
  document.addEventListener('mwApo::recalculated', schedule);
  document.addEventListener('shopify:product:select', event => {
    const promise = event.promise;
    if (promise?.then) promise.then(schedule, () => {});
  });
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  schedule();
})();
